/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantContactsViewModel } from '../../models/merchant-contacts-view-model';

export interface ListMerchantContact$Params {
  merchantId: string;
}

export function listMerchantContact(http: HttpClient, rootUrl: string, params: ListMerchantContact$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantContactsViewModel>> {
  const rb = new RequestBuilder(rootUrl, listMerchantContact.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantContactsViewModel>;
    })
  );
}

listMerchantContact.PATH = '/merchants/{merchantId}/contacts';
